import { axios } from 'lib/axios';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useAuth } from 'lib/auth';

const createShadowBuyer = async (data) => {
  data.VAT = `SE${data.VAT}01`;
  const { data: shadowBuyer } = await axios.post('/api/companies', {
    ...data,
    Type: 'buyer',
    Country: 'sweden',
    is_shadow: true,
  });

  return shadowBuyer;
};

const createRequest = async (values) => {
  if (values.mainBuyer) {
    const jsonData = {
      main_buyer_id: Number(values.mainBuyer),
      direct_name: values.directName,
      description: values.description,
      more_info_url: values.moreInfoURL,
      ref_number: values.refNumber,
      posting_date: values.postingDate,
      last_offer_date: values.lastOfferDate,
      start_date: values.startDate,
      end_date: values.endDate,
      status: values?.status,
      value: values?.value,
      additional_periods: values?.additionalPeriods,
      competence_areas: values?.competenceAreas,
    };

    return axios.post('/api/directs', JSON.stringify(jsonData));
  }

  const { mainBuyerName: Name, VAT, last_updated_user_id } = values;
  const shadowBuyer = await createShadowBuyer({ Name, VAT, last_updated_user_id });

  const data = {
    direct_name: values.directName,
    description: values.description,
    more_info_url: values.moreInfoURL,
    ref_number: values.refNumber,
    posting_date: values.postingDate,
    last_offer_date: values.lastOfferDate,
    start_date: values.startDate,
    end_date: values.endDate,
    status: values?.status,
    main_buyer_id: Number(shadowBuyer.company_id),
    value: values?.value,
    additional_periods: values?.additionalPeriods,
    competence_areas: values?.competenceAreas,
  };

  return axios.post('/api/directs', data);
};

export const useCreateDirect = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data) => createRequest({last_updated_user_id: user.user_id, ...data}),
    onSuccess: () => {
      enqueueSnackbar('Direct created successfully', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
